import styled, { css } from 'styled-components';

export type Variant = 'plain' | 'button';

export const Div = styled.div<{ $active: boolean; $variant?: Variant }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 10px;
  position: relative;
  ${({ $variant }) =>
    $variant === 'button' &&
    css`
      border: 1px solid ${({ theme }) => theme.colors.stroke};
      background-color: ${({ theme }) => theme.colors.white};
      height: 52px;
      width: 52px;
      border-radius: 3px;
    `}

  &::before {
    content: '';
    z-index: -1;
    display: block;
    position: absolute;
    width: 52px;
    height: 52px;
    background: transparent;
  }

  .MuiSvgIcon-root {
    color: ${({ theme }) => theme.colors.gp1};
    font-size: 35px;
    transition: 0.2s;

    ${({ $active }) =>
      $active &&
      css`
        transform: scale(1.1);
      `};

    &:hover {
      transform: scale(1.1);
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .MuiSvgIcon-root {
      font-size: 28px;
    }
    ${({ $variant }) =>
      $variant === 'button' &&
      css`
        height: 40px;
        width: 40px;
      `}
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    ${({ $variant }) =>
      $variant === 'button' &&
      css`
        height: 34px;
        width: 34px;
      `}
  }
`;
